<template>
  <div id="join-team">
    <p>You have been invited to join <strong class="project">{{ invitation.projectName }}</strong>
      by <strong>{{ invitation.adminEmail }}</strong>.<br>
      To get started, accept the invitation.</p>

    <div>
      <el-button
        type="text"
        size="large"
        @click.prevent="reject"
      >
        Decline
      </el-button>

      <el-button
        type="primary"
        size="large"
        :loading="loading"
        @click.prevent="accept"
      >
        Accept Invitation
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    invitation: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: mapState(['user']),
  methods: {
    reject () {
      this.loading = true
      this.$store.dispatch('declineInvitation', this.invitation.id)
        .then(() => this.$store.dispatch('getUser'))
    },
    accept () {
      this.loading = true
      this.$store.dispatch('acceptInvitation', this.invitation.id)
        .then((role) => {
          this.$store.dispatch('getUser').then(() => {
            this.$nextTick(() => {
              this.$store.dispatch('role', this.user.roles.find((r) => r.id === role.id))
              this.$router.push('/')
            })
          })
        })
    }
  },
  watch: {
    invitation () {
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
  @import "../../theme";

  #join-team {
    .project {
      color: $--color-primary;
    }

    p {
      word-break: break-word;
      font-size: 16px;
      line-height: 25px;
    }

    .el-button + .el-button {
      margin: 0;
    }
    .el-button--text {
      color: $--color-danger;
      float: right;
    }
  }
</style>
